module.exports = __webpack_public_path__ + "img/dcms01.e4b5dd79.png";